const Blister = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41 4C43.76 4 46 6.24 46 9V41C46 43.76 43.76 46 41 46H9C6.24 46 4 43.76 4 41V9C4 6.24 6.24 4 9 4H41ZM41 1H9C4.6 1 1 4.6 1 9V41C1 45.4 4.6 49 9 49H41C45.4 49 49 45.4 49 41V9C49 4.6 45.4 1 41 1Z"
        fill={color}
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25 10.502C16.993 10.502 10.502 16.993 10.502 25C10.502 28.9952 12.1181 32.613 14.7321 35.2354C14.8267 34.8362 14.9487 34.3716 15.105 33.853C15.6369 32.0875 16.569 29.6845 18.176 27.0975C21.0488 22.4728 26.0465 17.316 34.6234 14.1563C32.0635 11.8828 28.693 10.502 25 10.502ZM37.848 13.1151C34.6509 9.66061 30.078 7.498 25 7.498C15.3339 7.498 7.498 15.3339 7.498 25C7.498 34.6661 15.3339 42.502 25 42.502C34.6661 42.502 42.502 34.6661 42.502 25C42.502 20.5395 40.8334 16.4687 38.0863 13.3778L38.0019 13.0723C37.9505 13.0865 37.8992 13.1007 37.848 13.1151ZM36.8009 16.576C28.1879 19.4427 23.3968 24.3859 20.7278 28.6826C19.2848 31.0055 18.4519 33.1575 17.9813 34.7195C17.7462 35.4998 17.6023 36.1302 17.5182 36.5573C17.4762 36.7707 17.4491 36.9331 17.4331 37.0376C17.4251 37.0899 17.4198 37.1277 17.4168 37.1501L17.414 37.1721C17.414 37.1716 17.4141 37.1712 17.0562 37.13C19.3378 38.6272 22.0672 39.498 25 39.498C33.007 39.498 39.498 33.007 39.498 25C39.498 21.8585 38.4988 18.9503 36.8009 16.576Z"
        fill={color}
      />

      <path
        d="M41 4C43.76 4 46 6.24 46 9V41C46 43.76 43.76 46 41 46H9C6.24 46 4 43.76 4 41V9C4 6.24 6.24 4 9 4H41ZM41 1H9C4.6 1 1 4.6 1 9V41C1 45.4 4.6 49 9 49H41C45.4 49 49 45.4 49 41V9C49 4.6 45.4 1 41 1Z"
        stroke={color}
        strokeWidth="1.1265"
        strokeMiterlimit="10"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25 10.502C16.993 10.502 10.502 16.993 10.502 25C10.502 28.9952 12.1181 32.613 14.7321 35.2354C14.8267 34.8362 14.9487 34.3716 15.105 33.853C15.6369 32.0875 16.569 29.6845 18.176 27.0975C21.0488 22.4728 26.0465 17.316 34.6234 14.1563C32.0635 11.8828 28.693 10.502 25 10.502ZM37.848 13.1151C34.6509 9.66061 30.078 7.498 25 7.498C15.3339 7.498 7.498 15.3339 7.498 25C7.498 34.6661 15.3339 42.502 25 42.502C34.6661 42.502 42.502 34.6661 42.502 25C42.502 20.5395 40.8334 16.4687 38.0863 13.3778L38.0019 13.0723C37.9505 13.0865 37.8992 13.1007 37.848 13.1151ZM36.8009 16.576C28.1879 19.4427 23.3968 24.3859 20.7278 28.6826C19.2848 31.0055 18.4519 33.1575 17.9813 34.7195C17.7462 35.4998 17.6023 36.1302 17.5182 36.5573C17.4762 36.7707 17.4491 36.9331 17.4331 37.0376C17.4251 37.0899 17.4198 37.1277 17.4168 37.1501L17.414 37.1721C17.414 37.1716 17.4141 37.1712 17.0562 37.13C19.3378 38.6272 22.0672 39.498 25 39.498C33.007 39.498 39.498 33.007 39.498 25C39.498 21.8585 38.4988 18.9503 36.8009 16.576Z"
        stroke={color}
        strokeWidth="1.1265"
        strokeMiterlimit="10"
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Blister;
